import runWithFps from 'run-with-fps';
import Point, { distFast } from './point';
import { Vector } from 'v-for-vector';
import lerp from '@sunify/lerp-color';
import eases from 'eases';

var PIXEL_RATIO = (function () {
  var ctx = document.createElement('canvas').getContext('2d'),
    dpr = window.devicePixelRatio || 1,
    bsr =
      ctx.webkitBackingStorePixelRatio ||
      ctx.mozBackingStorePixelRatio ||
      ctx.msBackingStorePixelRatio ||
      ctx.oBackingStorePixelRatio ||
      ctx.backingStorePixelRatio ||
      1;

  return dpr / bsr;
})();

const canvasValue = (v) => v * PIXEL_RATIO;

export default (canvas) => {
  let { innerWidth: width, innerHeight: height } = window;

  const handleResize = () => {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = canvasValue(width);
    canvas.height = canvasValue(height);
  };
  window.addEventListener('resize', handleResize);
  handleResize();

  const ctx = canvas.getContext('2d');

  let points = [];

  const ttl = 400;
  const draw = () => {
    canvas.width = canvas.width; // eslint-disable-line

    points = points.filter(([_, t]) => Date.now() - t < ttl); // eslint-disable-line
    points.forEach(([p, t]) => {
      const age = eases.quadInOut((Date.now() - t) / ttl);
      ctx.strokeStyle = lerp(`rgba(255, 255, 40, 1)`, `rgba(255, 255, 250, 0.2)`, age);
      ctx.lineWidth = PIXEL_RATIO;
      p.update();
      const trace = p.vel
        .clone()
        .mult(2 / PIXEL_RATIO)
        .add(p.pos);

      ctx.beginPath();
      ctx.moveTo(trace.x, trace.y);
      ctx.lineTo(p.pos.x, p.pos.y);
      ctx.stroke();
    });
  };

  const emitParticles = (x, y) => {
    if (mouseTrack.length > 1) {
      const baseAngle = Math.atan2(mouseTrack[1][1] - mouseTrack[0][1], mouseTrack[1][0] - mouseTrack[0][0]);
      const baseLen = distFast(mouseTrack[0][0], mouseTrack[0][1], mouseTrack[1][0], mouseTrack[1][1]);

      for (let i = 0; i < 15; i += 1) {
        const angle = baseAngle + (Math.PI / 3) * (0.5 - Math.random()); // spread particles a little
        const len = Math.max(-40, -10 * (baseLen / 3)) * Math.random();
        points.push([
          new Point(
            Vector.cartesian(canvasValue(x), canvasValue(y)),
            Vector.polar(angle, len),
            Vector.polar(angle, len * 0.1 * Math.random())
          ),
          Date.now() + ttl * Math.random(),
          angle,
        ]);
      }
    }
  };

  let mouseMoving = false;
  let mouseTrack = [];
  let trackClearanceTimeout;

  const handleMove = (e) => {
    if (e.touches) {
      e.preventDefault();
    }
    if (mouseMoving === false) {
      mouseTrack = [];
    }
    mouseTrack.push([e.pageX, e.pageY]);
    mouseTrack = mouseTrack.slice(-2);
    mouseMoving = true;
    if (trackClearanceTimeout) {
      clearTimeout(trackClearanceTimeout);
    }

    emitParticles(e.pageX, e.pageY);

    trackClearanceTimeout = setTimeout(() => {
      mouseTrack = [];
      mouseMoving = false;
    }, 400);
  };
  document.addEventListener('mousemove', handleMove, { passive: true });
  // document.addEventListener('touchforcechange', () => undefined, false);
  // document.addEventListener('touchmove', handleMove, { passive: false });

  const fireworks = (x, y) => {
    for (let i = 0; i < 40; i += 1) {
      const angle = Math.PI * 2 * Math.random();
      const len = 30 + 120 * Math.random() * PIXEL_RATIO;
      points.push([
        new Point(Vector.cartesian(x, y), Vector.polar(angle, len), Vector.cartesian(0.7 * Math.cos(angle), 0.5)),
        Date.now() + Math.random() * 1000,
        angle,
      ]);
    }
  };

  const handleClick = () => {
    for (let i = 0; i < 10; i++) {
      setTimeout(() => {
        requestAnimationFrame(() => {
          fireworks(canvasValue(width) * Math.random(), canvasValue(height) * Math.random());
        });
      }, 2500 * Math.random());
    }
  };

  document.addEventListener('mouseup', handleClick);
  document.addEventListener('touchend', handleClick);

  runWithFps(draw, 24);

  return {
    doPyshPysh: handleClick,
  };
};
